import React, { useEffect, useState } from 'react';
import { findItemByValueRecursively } from 'components/Layout/CommonService';
import { setActiveView } from 'features/applicationState';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import NIService, { INIService } from 'services/NIService';
import { RootState, SidebarItem } from 'types/types';
import UserManager from 'utils/UserManager';
import { Grid, Box } from '@mui/material';
import { generateQueryParams, getSidebarItemProp } from 'utils/Utils';
import { ReactComponent as PinSvg } from 'assets/images/pin.svg';
import { ReactComponent as UnpinSvg } from 'assets/images/unpin.svg';
import { getCustomCss } from 'utils/customCss';


function LandingDashboards() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch(); 
  const customCss = getCustomCss(); 
  let folderName = customCss != null ? customCss + '/' : 'default/';
  const queryParams = new URLSearchParams(location.search);
  const appId = queryParams.get('selectedApp') || '';
  const { sidebarItems } = useSelector(
    (state: RootState) => state.applicationState
  );
  const [selectedAppItems, setSelectedAppItems] = useState<
    (SidebarItem | null)[]
  >([]);
  const [favoriteDashboardItems, setfavoriteDashboardItems] = useState<
    (SidebarItem | null)[]
  >([]);

  const getDashboardBackgroundImg = (item: SidebarItem | null) => { 
    if (!item) return '';
    return (
      'styles/images/dashboards/' + folderName + 
      getSidebarItemProp(item, 'background', 'DashboardBg.png')
    );
  };
  
  const openDashboard = (item) => {
    const queryParams = generateQueryParams(item.properties);
    const vurl = item.value;
    const viewType = item.type.toLowerCase();
    navigate('/' + viewType + '/' + vurl + '?' + queryParams);
  };

  const markFavorites = async (item) => {
    const updatedSelectedAppItems = selectedAppItems.map((appItem) => {
      if (appItem?.items) {
        const updatedItems = appItem.items.map((subItem) => {
          if (subItem.value === item.value) {
            if (!subItem.favorite) {
              setfavoriteDashboardItems([
                ...favoriteDashboardItems,
                subItem as SidebarItem,
              ]);
              return { ...subItem, favorite: true };
            } else {
              setfavoriteDashboardItems(
                favoriteDashboardItems.filter((n) => n?.value !== item.value)
              );
              return { ...subItem, favorite: false };
            }
          }
          return subItem;
        });
        return { ...appItem, items: updatedItems };
      }
      return appItem;
    });
    setSelectedAppItems(updatedSelectedAppItems);

    var favoriteDashboards: string[] = [];
    var userProperties = UserManager.getProperties();
    if (userProperties['favoriteDashboards'])
      favoriteDashboards = userProperties['favoriteDashboards'].split(',');

    var favDashIndex = favoriteDashboards.indexOf(item.value);
    if (favDashIndex === -1) favoriteDashboards.push(item.value);
    else favoriteDashboards.splice(favDashIndex, 1);

    var property = {
      Name: 'favoriteDashboards',
      Value: favoriteDashboards.join(),
    };
    const niService: INIService = new NIService();
    await niService.AddUserProerties(property);
    UserManager.setProperty(property.Name, property.Value);
  };

  useEffect(() => { 
    const selectedApp = findItemByValueRecursively(appId, sidebarItems);
    if (!selectedApp) {
      navigate('/view/landingPageView');
    }
    let selectedAppItems = [selectedApp];
    if (
      selectedApp?.items &&
      selectedApp.items[0] &&
      selectedApp.items[0].type === 'FOLDER'
    ) {
      selectedAppItems = [];

      selectedApp.items.forEach((appItem) => {
        appItem.items.forEach((item) => {
          let navItem;
          if (item.type === 'FOLDER' && item.items && item.items.length > 0) {
            navItem = { ...item };
            navItem.text = appItem.text + ' - ' + item.text;
            selectedAppItems.push(navItem);
          } else {
            const existItem = selectedAppItems.filter(
              (n) => n?.value === appItem.value
            );
            if (existItem.length === 0) {
              navItem = { ...appItem };
              navItem.items = appItem.items.filter((n) => n.type !== 'FOLDER');
              selectedAppItems.push(navItem);
            }
          }
        });
      });
    }

    const favoriteDashboardItems: SidebarItem[] = [];
    let favoriteDashboards: string[] = [];
    let landingDashboardsTitle = selectedApp ? selectedApp.text : 'Dashboards';
    var userProperties = UserManager.getProperties();
    if (userProperties['favoriteDashboards']) {
      favoriteDashboards = userProperties['favoriteDashboards'].split(',');
      selectedAppItems = selectedAppItems.map((appItem) => {
        const items = appItem?.items.map((dashItem) => {
          const favDashIndex = favoriteDashboards.indexOf(dashItem.value);
          dashItem = { ...dashItem, favorite: favDashIndex !== -1 };
          if (dashItem.favorite) favoriteDashboardItems.push(dashItem);
          return dashItem;
        });
        return { ...appItem, items: items };
      }) as SidebarItem[];
    }

    setSelectedAppItems(selectedAppItems);
    setfavoriteDashboardItems(favoriteDashboardItems);
    dispatch(
      setActiveView({
        viewId: 'landingDashboards',
        title: landingDashboardsTitle,
        properties: [{ Name: 'appTitle', Value: landingDashboardsTitle }],
      })
    );
  }, [appId, sidebarItems, navigate, dispatch]); 
  return (
    <div id="main-area">
      <div id="main-area-landing-dashboards" className="main-view-container">
        {favoriteDashboardItems?.length > 0 && (
          <div>
            <div className="favorite-Dashboard-title">
              Favorite Dashboards
            </div>
            <Grid
              id="main-area-landing-page-app-container"
              container
              spacing={4}
              columns={12}
              direction="row"
              justifyContent="flex-start"
              alignContent="center"
              alignItems="center"
            >
              {favoriteDashboardItems.map((item, index) => (
                <Grid item xs={3} alignContent="flex-start" key={index}>
                  <div className="main-menu-item">
                    <Box className="item-block-head">
                      <div
                        onClick={() => openDashboard(item)}
                        className="main-area-landing-page-app-title addHover"
                      >
                        {item?.text}
                      </div>
                      <div  className='addHover' onClick={() => markFavorites(item)}>
                        <PinSvg />
                      </div>
                    </Box>
                    <div
                      onClick={() => openDashboard(item)}
                      className="landing-page-favorite-dashboard-bkg addHover"
                    >
                      <img
                        className="landing-page-favorite-dashboard-bkg-img"
                        src={getDashboardBackgroundImg(item)}
                        alt="open"
                      />
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
            {/* <ul id="main-area-landing-page-favorite-dashboards">
                <li key={index} style={{ borderTopColor: '#f3a442' }} className='main-menu-item'>
                </li>
            </ul> */}
          </div>
        )}
        {selectedAppItems?.map((item, index) => {
          return (
            <div className="pd-bottom-32" key={index}>
              <div className="landing-page-app-folder-title">{item?.text}</div>
              <Grid
                id="main-area-landing-page-app-folder-dashboards"
                container
                spacing={4}
                columns={12}
                direction="row"
                justifyContent="flex-start"
                alignContent="center"
                alignItems="stretch"
              >
                {item?.items?.map((subItem, index) => {
                  return (
                    <Grid
                      item
                      xs={3}
                      className='addHover'
                      alignContent="flex-start"
                      key={subItem.value + index}
                      onClick={() => openDashboard(subItem)}
                    >
                      <div className="main-menu-item">
                        <Box className="item-block-head">
                          <div className="main-area-landing-page-app-title">
                            {subItem.text}
                          </div>
                          <div className='addHover'
                            onClick={(e) => {
                              e.stopPropagation();
                              markFavorites(subItem);
                            }}
                            title="#=data.favorite ? 'Unbookmark this dashboard': 'Bookmark this dashboard'#"
                          >
                            {subItem.favorite ? <PinSvg /> : <UnpinSvg />}
                          </div>
                        </Box>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LandingDashboards;
